/* 22-10: applica le cornici alle card (vedi snippets/aaf-card-frames.liquid) */
(function () {
  if (window.__aafFx) return; window.__aafFx = true;
  var BASE = ['start', 'viral', 'best', 'gift'];
  var ALL = ['start', 'viral', 'best', 'gift', 'winter', 'xmas'];
  function season() {
    if (/[?&]aaf_natale=1/.test(location.search)) { try { sessionStorage.setItem('aafNatale', '1'); } catch (e) {} return true; }
    try { if (sessionStorage.getItem('aafNatale') === '1') return true; } catch (e) {}
    var d = new Date(), m = d.getMonth() + 1, g = d.getDate();
    return (m === 11 && g >= 24) || m === 12 || (m === 1 && g <= 6);
  }
  var XMAS = season();
  function apply(m) {
    m.setAttribute('data-done', '1');
    var card = m.closest('.product-card');
    var box = card && card.querySelector('.product-card__image__container');
    if (!box) return;
    var f = m.getAttribute('data-f') || '';
    var want = f;
    if (m.getAttribute('data-x') === '1' && XMAS && ['start', 'viral', 'best'].indexOf(f) < 0) want = 'xmas';
    if (!want) return;
    var has = ALL.filter(function (k) { return card.classList.contains('aaf-' + k); });
    if (has.indexOf(want) >= 0) return;
    if (has.some(function (k) { return BASE.indexOf(k) >= 0; })) {
      if (want !== 'xmas') return;
      /* in stagione Natale passa davanti a "Il regalo più amato": tolgo la cornice della card */
      has.forEach(function (k) { card.classList.remove('aaf-' + k); });
      box.querySelectorAll('.aaf-gift-bow, .aaf-gift-pill').forEach(function (e) { e.remove(); });
    }
    var grp = m.querySelector('[data-k="' + want + '"]');
    if (!grp) return;
    card.classList.add('aaf-' + want);
    var img = box.querySelector(':scope > .product-card__image') || box.firstChild;
    while (grp.firstChild) box.insertBefore(grp.firstChild, img);
  }
  function run() { document.querySelectorAll('.aaf-fx:not([data-done])').forEach(apply); }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(run, 80); }
  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true });
})();
